<template>
  <div class="info">
    <div class="title">场馆信息</div>
    <div class="stadium-info">
      <div class="item">
        <div class="name">场馆名称</div>
        <div class="val">东方体育中心游泳馆</div>
      </div>
      <div class="item">
        <div class="name">场馆地址</div>
        <div class="val">浦东新区 耀体路701号</div>
      </div>
      <div class="item">
        <div class="name">经营许可证</div>
        <div class="val">浦体许310115【2013】0001号</div>
      </div>
      <div class="item">
        <div class="name">高危许可证</div>
        <div class="val">许可证编号331002201601</div>
      </div>
    </div>
    <div class="title">场馆人员</div>
    <a-row class="person-info" :gutter="32">
      <a-col span="12" v-for="(item, index) in list" :key="index">
        <div class="item">
          <div class="avatar">
            <img src="../../assets/dongti/person.png" />
          </div>
          <div class="i-item">
            <span>姓名</span>
            <span class="val">{{ item.name }}</span>
          </div>
          <div class="i-item">
            <span>岗位</span>
            <span class="val">{{ item.label }}</span>
          </div>
          <!-- <div class="i-item">
            <span>持证</span>
            <span class="val">有效期内</span>
          </div> -->
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      list: [],
    }
  },
  computed: {
    ...mapState({
      sid: (state) => state.user.sid,
    }),
  },
  mounted() {
    this.get_guard()
  },
  methods: {
    get_guard() {
      this.$http({
        url: 'stadium/guards',
        method: 'post',
        data: {
          sid: this.sid,
        },
      }).then((r) => {
        this.list = r.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.info {
  color: #fff;
  padding: 0 30px;
  height: 100%;
  .title {
    margin-top: 24px;
    margin-bottom: 15px;
    font-weight: 500;
    font-size: 18px;
  }
  .stadium-info {
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #beecff;
      padding: 7px 0 5px;
      border-bottom: 1px solid #79d9ff;
      .val {
        color: #00cbff;
      }
    }
  }
  .person-info {
    height: 62%;
    overflow: auto;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 6px;
      border-bottom: 1px solid #79d9ff;
      margin-bottom: 20px;
      .avatar {
        margin-bottom: 10px;
        img {
          width: 52px;
          height: 52px;
        }
      }
      .i-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-size: 14px;
        color: #beecff;
        padding: 0 0px 2px;
        .val {
          color: #00cbff;
        }
      }
    }
  }
}
</style>
